import React from 'react';
import { useTranslation } from 'react-i18next';
import NativeDropdown from '../../../../Dropdown/NativeDropdown';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { BiData, } from '@wix/da-bi/pkg/events';
import { useRestrictToLoggedIn } from '../../../../utils/hooks/useRestrictToLoggedIn';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import { useDeviationAttributes } from '../../../../DeviationViews/hooks/useDeviationAttributes';
import s from './MoreMenuMobileDropdown.scss';
var MoreMenuMobileDropdown = function (_a) {
    var deviation = _a.deviation, isOwner = _a.isOwner, showReportModal = _a.showReportModal, showMobileDeviationSharePopup = _a.showMobileDeviationSharePopup, shareDeviationToPost = _a.shareDeviationToPost;
    var t = useTranslation().t;
    var _b = useRestrictToLoggedIn(), isLoggedIn = _b.isLoggedIn, sendUserToJoinPage = _b.sendUserToJoinPage;
    var _c = useDeviationAttributes(deviation, isOwner), isShareable = _c.isShareable, isReportable = _c.isReportable;
    var onSelect = function (value) {
        switch (value) {
            case 'share':
                showMobileDeviationSharePopup(deviation);
                break;
            case 'sharetopost':
                isLoggedIn
                    ? shareDeviationToPost(deviation)
                    : sendUserToJoinPage(ReferralType.SHARE_TO_POST);
                break;
            case 'report':
                showReportModal(deviation);
                break;
            default:
        }
    };
    return (React.createElement(NativeDropdown, { className: s['root'], onSelect: onSelect, openBiData: {
            evid: BiEventType.MORE_MENU_CLICK,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
            sectionname: 'deviation',
        }, items: [
            isShareable && {
                value: 'share',
                label: t('actionbar.share'),
                biData: BiData({
                    evid: 355,
                    typeid: getDeviationResourceType(deviation),
                    itemid: deviation.deviationId,
                    deviationid: deviation.deviationId,
                }),
            },
            isShareable && {
                value: 'sharetopost',
                label: t('actionbar.shareToPost'),
                biData: BiData({
                    evid: 356,
                    typeid: getDeviationResourceType(deviation),
                    itemid: deviation.deviationId,
                    social_share: 'da_post',
                    deviationid: deviation.deviationId,
                }),
            },
            isReportable && {
                value: 'report',
                label: t('actionbar.report'),
                biData: BiData({
                    evid: 20,
                    modal_version: 2,
                    deviationid: deviation.deviationId,
                }),
            },
        ] }));
};
MoreMenuMobileDropdown.displayName = 'MoreMenuMobileDropdown';
export default MoreMenuMobileDropdown;
//# sourceMappingURL=MoreMenuMobileDropdown.js.map